import { Typography } from 'antd'
import type { CSSProperties, ReactNode } from 'react'

const { Text } = Typography

type Props = {
  children?: ReactNode
  style?: CSSProperties
}

/**
 * Unified section label rendered above a sub-component or stat: 11px, uppercase,
 * 0.06em letter-spacing, tertiary text colour. Centralizes the repeated inline
 * style block so the look stays consistent across the app (per CLAUDE.md rule 8).
 */
export const SectionLabel = ({ children, style }: Props) => (
  <Text
    style={{
      fontSize: 11,
      textTransform: 'uppercase',
      letterSpacing: '0.06em',
      color: 'var(--ant-color-text-tertiary)',
      ...style
    }}
  >
    {children}
  </Text>
)
